// import app from "gridsome/lib/app";
import { Commons } from '../../utils/commons'
import { AppData } from './appData'
import filtersPriority from '@/utils/raws/filtersPriority.json'

class Formatter {
  static parseExternalVersionInfo(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('appVersionData').setMetaData({
      ...raw,
      appLastestVersion: raw.appLastestVersion || '',
      appLink: raw.appLink || '',
      appUpdateTitle: raw.appUpdateTitle || '',
      appUpdateDescription: raw.appUpdateDescription || '',
    })
    return appData
  }

  static parseExternalAppInfo(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('appInfo').setMetaData({
      ...raw,
      bannerMessage: raw.bannerMessage || '',
      facebookLink: raw.facebookLink || '',
      instagramLink: raw.instagramLink || '',
      tiktokLink: raw.tiktokLink || '',
      websiteLink: raw.websiteLink || '',
      affiliationDetailText: raw.affiliationDetailText || '',
      whatsappComplaintLink: raw.whatsappComplaintLink || '',
      passwordResetUrl: raw.passwordResetUrl || '',
      faqUrl: raw.faqUrl || '',
      policyUrl: raw.policyUrl || '',
      cguUrl: raw.cguUrl || '',
      email: raw.email || '',
      rechargeVideoLink: raw.rechargeVideoLink || '',
      rechargeTutorialLink: raw.rechargeTutorialLink || '',
      snapchatLink: raw.snapchatLink || '',
      userCurrency: raw.userCurrency || '',
      minAmountForTransaction: raw.minAmountForTransaction || '',
      minAmountBuyXbet: raw.minAmountBuyXbet || '',
      minAmountSellXbet: raw.minAmountSellXbet || '',
      minAmountBuyOneWin: raw.minAmountBuyOneWin || '',
      minAmountSellOneWin: raw.minAmountSellOneWin || '',
      minAmountBuyBetwinner: raw.minAmountBuyBetwinner || '',
      minAmountSellBetwinner: raw.minAmountSellBetwinner || '',
      minAmountBuyMelbet: raw.minAmountBuyMelbet || '',
      minAmountSellMelbet: raw.minAmountSellMelbet || '',
      minAmountBuyEightStarz: raw.minAmountBuyEightStarz || '',
      minAmountSellEightStarz: raw.minAmountSellEightStarz || '',
      minAmountBuyPm: raw.minAmountBuyPm || '',
      minAmountSellPm: raw.minAmountSellPm || '',
      minAmountBuyUsdt: raw.minAmountBuyUsdt || '',
      minAmountSellUsdt: raw.minAmountSellUsdt || '',
      vipSubscriptionAmount: raw.vipSubscriptionAmount || '2500',
      xbetDownloadUrl: raw.xbetDownloadUrl || '',
      betwinnerDownloadUrl: raw.betwinnerDownloadUrl || '',
      melbetDownloadUrl: raw.melbetDownloadUrl || '',
      eightStarzDownloadUrl: raw.eightStarzDownloadUrl || '',
      oneWinDownloadUrl: raw.oneWinDownloadUrl || '',
      netflixDownloadUrl: raw.netflixDownloadUrl || '',
      primeVideoDownloadUrl: raw.primeVideoDownloadUrl || '',
      disneyDownloadUrl: raw.disneyDownloadUrl || '',
      crunchyrolDownloadUrl: raw.crunchyrolDownloadUrl || '',
      spotifyDownloadUrl: raw.spotifyDownloadUrl || '',
      nordVPNDownloadUrl: raw.nordVPNDownloadUrl || '',
      privateVPNDownloadUrl: raw.privateVPNDownloadUrl || '',
      cyberGhostDownloadUrl: raw.cyberGhostDownloadUrl || '',
      adnDownloadUrl: raw.adnDownloadUrl || '',
    })
    return appData
  }

  static parseExternalContacts(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('contacts').setMetaData({
      ...raw,
      GA: {
        whatsappPhoneNumber: raw?.GA?.whatsappPhoneNumber,
        whatsappPhoneNumberComplaint: raw?.GA?.whatsappPhoneNumberComplaint,
        whatsappLink: raw?.GA?.whatsappLink,
        whatsappChatLink: raw?.GA?.whatsappChatLink,
        telegramLink: raw?.GA?.telegramLink,
      },
      ALL: {
        whatsappPhoneNumber: raw?.ALL?.whatsappPhoneNumber,
        whatsappPhoneNumberComplaint: raw?.ALL?.whatsappPhoneNumberComplaint,
        whatsappLink: raw?.ALL?.whatsappLink,
        whatsappChatLink: raw?.ALL?.whatsappChatLink,
        telegramLink: raw?.ALL?.telegramLink,
      },
    })
    return appData
  }

  static parseExternalRates(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('rates').setMetaData({
      buyRates: {
        USDT: {
          XOF: raw?.buyRates?.USDT?.XOF || 0,
          XAF: raw?.buyRates?.USDT?.XAF || 0,
        },
      },
      sellRates: {
        USDT: {
          XOF: raw?.sellRates?.USDT?.XOF || 0,
          XAF: raw?.sellRates?.USDT?.XAF || 0,
        },
      },
    })
    return appData
  }

  static parseExternalAddresses(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('addresses').setMetaData({
      ...raw,
      usdtTrc20Address: raw?.usdtTrc20Address || '',
      usdtErc20Address: raw?.usdtErc20Address || '',
      usdtBep20Address: raw?.usdtBep20Address || '',
      binanceAccountId: raw?.binanceAccountId || '',
      pmAdress: raw?.pmAdress || '',
      betwinnerWithdrawAddress: raw?.betwinnerWithdrawAddress || '',
      betwinnerWithdrawProcessus: raw?.betwinnerWithdrawProcessus || '',
      eightStarzWithdrawAddress: raw?.eightStarzWithdrawAddress || '',
      eightStarzWithdrawProcessus: raw?.eightStarzWithdrawProcessus || '',
      melbetWithdrawAddress: raw?.melbetWithdrawAddress || '',
      melbetWithdrawProcessus: raw?.melbetWithdrawProcessus || '',
      withdrawVideoLink: raw?.withdrawVideoLink || '',
      withdrawTutorialLink: raw?.withdrawTutorialLink || '',
      xbetWithdrawAddress: raw?.xbetWithdrawAddress || '',
      xbetWithdrawProcessus: raw?.xbetWithdrawProcessus || '',
      oneWinWithdrawProcessus: raw?.oneWinWithdrawProcessus || '',
    })
    return appData
  }

  static parseExternalOtpUssdCodes(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('otpUssdCodes').setMetaData({
      ...raw,
    })
    return appData
  }

  static parseExternalAffiliationData(raw) {
    if (!raw) return null
    const appData = new AppData()
    let code = raw.code
    if (Array.isArray(raw.aliases) && raw.aliases.length)
      code = raw.aliases[raw.aliases.length - 1]
    const data = {
      ...raw,
      amount: raw.amount || 0,
      url: code
        ? `https://kingrecharges.com?ref=${code}`
        : 'https://kingrecharges.com',
      code: code || 'xxx-xxx',
    }
    appData.setContent('affiliationData').setMetaData(data)
    return appData
  }

  static parseExternalAccountLocked(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('accountLocked').setMetaData({
      ...raw,
      isLocked: raw.isLocked,
    })
    return appData
  }

  static parseUserLockedResponse(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('isLockedData').setMetaData(formatIsLockedData(raw))
    return appData
  }

  static parseExternalLocationData(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent("locationData").setMetaData({
      locationData: {
        countryCode: raw.country_code,
        countryCode: raw.country,
      },
    });
    return appData
  }

  static parseExternalStats(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('stats').setMetaData({
      todayBookmakerFunding: raw.todayBookmakerFunding || 0,
      accessToDailyVip: raw.accessToDailyVip || false,
      dailyVipMinAmount: raw.dailyVipMinAmount || 0,
    })
    return appData
  }

  static parseExternalSubscription(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('subscription').setMetaData({
      isActive: raw.status == 'active',
      status: raw.status || 'inactif',
      amount: raw.amount || 0,
      endDate: raw.endDate || '0',
    })
    return appData
  }

  static parseExternalWalletInfo(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('walletInfo').setMetaData({
      balance: raw.balance || '0',
    })
    return appData
  }

  static parseExternalPubs(rawPubs, isCouponsPubs = false) {
    if (!rawPubs) return null
    const appData = new AppData()
    appData
      .setContent(isCouponsPubs ? 'couponsPubs' : 'pubs')
      .setMetaData(formatPubsMetaData(rawPubs))
    return appData
  }

  static parseExternalGiftCards(rawCards) {
    if (!rawCards) return null
    if (!Array.isArray(rawCards)) return null
    const appData = new AppData()
    appData.setContent('giftCards').setMetaData({
      cards: rawCards.map(card => {
        return {
          ...card,
          id: card.id,
          name: card.name,
          unitAmounts: card.metadata.unitAmounts,
          minAmount: card.metadata.minAmount,
          maxAmount: card.metadata.maxAmount,
          rateToXof: card.metadata.rateToXof,
          currency: card.metadata.currency,
          image: card.metadata.image,
        }
      }),
    })
    return appData
  }

  static parseExternalPlatformSubscriptionsData(raw) {
    if (!raw) return null
    if (!Array.isArray(raw)) return null
    const appData = new AppData()
    appData.setContent('platformSubscriptions').setMetaData({
      subscriptions: raw.map(subscription => {
        return {
          ...subscription,
          id: subscription.id,
          name: subscription.name,
          unitAmount: subscription.metadata.unitAmount,
          image: subscription.metadata.image,
          platformId: subscription.metadata.platformId,
        }
      }),
    })
    return appData
  }

  static parseExternalCoupons(rawCoupons) {
    if (!rawCoupons) return null
    const appData = new AppData()
    appData.setContent('coupons').setMetaData(formatCouponsMetaData(rawCoupons))
    return appData
  }

  static parseTopMatches(rawPubs) {
    if (!rawPubs) return null
    const appData = new AppData()
    appData.setContent('topMatches').setMetaData(formatMatchesMetaData(rawPubs))
    return appData
  }

  static parseLiveMatches(rawMatches) {
    if (!rawMatches) return null
    const appData = new AppData()
    appData
      .setContent('liveMatches')
      .setMetaData(formatMatchesMetaData(rawMatches, true))
    return appData
  }

  static parseUpcomingMatches(matches) {
    if (!matches) return null
    const appData = new AppData()
    appData
      .setContent('upcomingMatches')
      .setMetaData(formatMatchesMetaData(matches))
    return appData
  }

  static parseMatchFilters(upcoming, live) {
    if (!upcoming || !live) return null
    const appData = new AppData()
    appData
      .setContent('matchFilters')
      .setMetaData(formatMatchFiltersMetaData(upcoming, live))
    return appData
  }

  static formatFiltersSelected(filters) {
    if (!Array.isArray(filters)) return null
    const appData = new AppData()
    appData
      .setContent('selectedFilters')
      .setMetaData({ filters: JSON.parse(JSON.stringify(filters)) })
    return appData
  }

  static formatFilteredMatches(matches, isLive) {
    if (!Array.isArray(matches)) return null
    const appData = new AppData()
    appData
      .setContent(isLive ? 'liveFilteredMatches' : 'upcomingFilteredMatches')
      .setMetaData({
        isSorted: true,
        updatedAt: Date.now(),
        topMatches: matches,
      })
    return appData
  }

  static groupMatches(matches) {
    if (!Array.isArray(matches)) return null
    const appData = new AppData()
    const groups = {}
    const livesGroups = {}
    const groupIds = {}
    matches.forEach(match => {
      const dateId = `${match.date}-${match.month}-${match.year}`
      if (!groups[dateId]) {
        groups[dateId] = []
        livesGroups[dateId] = []
        groupIds[dateId] = {
          day: match.day,
          date: match.date,
          month: match.month,
          year: match.year,
          id: dateId,
          // status: match.matchStatus,
          // hasLive: match.isLive,
        }
      }
      if (match.isLive) {
        livesGroups[dateId].push(match)
        groupIds[dateId].hasLive = true
      } else groups[dateId].push(match)
    })
    Object.keys(livesGroups).forEach(key => {
      livesGroups[key] = livesGroups[key].sort((match1, match2) => {
        let match1Priority = Math.min(
          filtersPriority[match1.country] || 9999999,
          filtersPriority[match1.league] || 9999999,
          9999999,
        )
        let match2Priority = Math.min(
          filtersPriority[match2.country] || 9999999,
          filtersPriority[match2.league] || 9999999,
          9999999,
        )
        return match1Priority - match2Priority
        // if(match1Priority<match2Priority) return -1
        // console.log(match1Priority, match2Priority)
      })
    })
    Object.keys(groups).forEach(key => {
      groups[key] = groups[key].sort((match1, match2) => {
        let match1Priority = Math.min(
          filtersPriority[match1.country] || 9999999,
          filtersPriority[match1.league] || 9999999,
          9999999,
        )
        let match2Priority = Math.min(
          filtersPriority[match2.country] || 9999999,
          filtersPriority[match2.league] || 9999999,
          9999999,
        )
        return match1Priority - match2Priority
        // if(match1Priority<match2Priority) return -1
        // console.log(match1Priority, match2Priority)
      })
    })
    appData.setContent('groupedMatches').setMetaData({
      isSorted: true,
      updatedAt: Date.now(),
      groupIds: Object.values(groupIds),
      groups,
      livesGroups,
    })
    return appData
  }

  static buildAppDataEntity(rawData) {
    if (!rawData) return null
    const appData = new AppData()
    appData.setContent(rawData.content).setMetaData(rawData.metaData)
    return appData
  }

  static mergePreferences(savedPreferences, newPreferencesContent) {
    const appData = new AppData()
    appData.setContent('userPreferences').setMetaData({
      ...(savedPreferences?.metaData || {}),
      ...(newPreferencesContent || {}),
    })
    return appData
  }

  static parseUiMatches(data) {
    if (!Array.isArray(data?.metaData?.topMatches)) return data
    data.metaData.topMatches = data.metaData.topMatches.map(match => {
      let usedMarkey = {}
      if (match.markets)
        usedMarkey = {
          win1: match.markets.win1,
          win2: match.markets.win2,
          winX: match.markets.winX,
          win12: match.markets.win12,
          win1X: match.markets.win1X,
          winX2: match.markets.winX2,
        }
      match.markets = usedMarkey
      return {
        ...match,
        team1Picture: '/images/football.svg',
        team2Picture: '/images/football.svg',
      }
    })
    if (!data.metaData.isSorted) {
      data.metaData.topMatches = data.metaData.topMatches.sort(
        (match1, match2) => {
          if (match1.startTimestamp > match2.startTimestamp) return 1
          if (match1.startTimestamp < match2.startTimestamp) return -1
          return 0
        },
      )
    }
    return data
  }
}

function formatIsLockedData(raw = {}) {
  const metaDataKeys = ['isLocked']
  return formatMetaData(raw, metaDataKeys)
}

function formatMetaData(source, keys) {
  const metaData = {}
  keys.forEach(key => {
    metaData[key] = source[key]
  })
  return metaData
}

function formatPubsMetaData(rawPubs = []) {
  if (!Array.isArray(rawPubs)) return { pubs: [] }
  return {
    pubs: rawPubs.map(pub => {
      return {
        title: pub.title,
        description: pub.description,
        pictureUrl: pub.pictureUrl,
        actionTitle: pub.actionTitle,
        action: pub.action,
        isCouponsPub: pub.isCouponsPub,
        date: pub.date,
      }
    }),
  }
}

function formatCouponsMetaData(rawCoupons = []) {
  if (!Array.isArray(rawCoupons)) return { coupons: [] }
  return {
    coupons: rawCoupons.map(coupon => {
      return {
        pictureUrl: coupon.pictureUrl,
        isVip: coupon.isVip,
        code: coupon.code || '',
        isValidated: coupon.isValidated || false,
        bookmaker: coupon.bookmaker || '',
      }
    }),
  }
}

// function formatMatchesMetaData(rawTopMatches = []) {
//   if (!Array.isArray(rawTopMatches)) return { pubs: [] };
//   return {
//     topMatches: rawTopMatches.map((match, i) => {
//       let statusDisplay = "Non démaré";
//       if (match.matchStatus == "finished") statusDisplay = "Terminé";
//       if (match.matchStatus == "starting") statusDisplay = "En cours";
//       if (match.matchStatus == "live") statusDisplay = "En cours";
//       return {
//         id: i,
//         startTimestamp: match.startTimestamp,
//         day: match.day,
//         month: match.month,
//         year: match.year,
//         liveDurationMin: match.liveDurationMin,
//         dateDisplay: Commons.timestampToDate(
//           match.startTimestamp,
//           "DD MMM YYYY HH:mm"
//         ),
//         statusDisplay,
//         matchStatus: match.matchStatus,
//         startHour: match.startHour,
//         startMin: match.startMin,
//         matchId: match.matchId,
//         competitionName: match.competitionName,
//         matchPageUrl: match.matchPageUrl,
//         team1Name: match.team1Name,
//         team2Name: match.team2Name,
//         team1Score: match.team1Score,
//         team2Score: match.team2Score,
//         team1Picture: match.team1Picture,
//         team2Picture: match.team2Picture,
//       };
//     }),
//   };
// }

function formatMatchesMetaData(rawTopMatches = [], isLive = false) {
  if (!Array.isArray(rawTopMatches)) return { topMatches: [] }
  console.log(rawTopMatches.length)
  return {
    isSorted: true,
    updatedAt: Date.now(),
    topMatches: rawTopMatches
      .map((match, i) => {
        const date = new Date(match.start)
        const startTimestamp = date.getTime()
        const matchStatus = isLive ? 'live' : 'notStarted'
        let statusDisplay = 'Non démaré'
        if (matchStatus == 'live') statusDisplay = 'En cours'
        const durationMin = match.durationMin
        if (!window.matches) window.matches = { countries: [], leagues: [] }
        window.matches.countries = [
          ...new Set([...window.matches.countries, match.location.country]),
        ]
        window.matches.leagues = [
          ...new Set([...window.matches.leagues, match.league]),
        ]

        return {
          id: i,
          isLive,
          startTimestamp,
          day: date.getDay(),
          date: date.getDate(),
          month: date.getMonth(),
          year: date.getFullYear(),
          liveDurationMin: durationMin,
          dateDisplay: Commons.timestampToDate(
            date.getTime(),
            'DD MMM YYYY HH:mm',
          ),
          statusDisplay,
          matchStatus: matchStatus,
          startHour: date.getHours(),
          startMin: date.getMinutes(),
          league: match.league,
          country: match.location?.country,
          city: match.location?.city,
          matchName: getMatchName(match.teams.home, match.teams.away),
          team1Name: match.teams.home,
          team2Name: match.teams.away,
          team1Score: match.score.home,
          team2Score: match.score.away,
          team1Picture: match.logo.home,
          team2Picture: match.logo.away,
          // ...match,
          odds: match.odds,
          statistics: match.statistics,
        }
      })
      // .filter(match => {
      //   const now = Date.now()
      //   const maxMatchDuration = 120 * 2 * 60 * 1000
      //   return match.startTimestamp >= now - maxMatchDuration
      // })
      .sort((match1, match2) => {
        if (match1.startTimestamp > match2.startTimestamp) return 1
        if (match1.startTimestamp < match2.startTimestamp) return -1
        return 0
      }),
    // .splice(0, 5000),
  }
}

function formatMatchFiltersMetaData(upcoming = [], live = []) {
  if (!Array.isArray(upcoming) || !Array.isArray(live)) return { filters: [] }
  const filtersIds = {}
  return {
    updatedAt: Date.now(),
    filters: [...live, ...upcoming]
      .map((filter, i) => {
        if (filtersIds[filter.league_id]) return null
        if (/[Государственный'||"{?;]/i.test(filter.league || filter.title))
          return null
        filtersIds[filter.league_id] = true
        return {
          id: filter.league_id,
          name: filter.league || filter.title,
          title: filter.title,
          ...filter,
        }
      })
      .filter(filter => !!filter),
  }
}

function getMatchName(team1, team2) {
  let max = 15
  let team1Short = team1.slice(0, max)
  let team2Short = team2.slice(0, max)
  if (team1.length > max) team1Short = team1.slice(0, max - 3) + '...'
  if (team2.length > max) team2Short = team2.slice(0, max - 3) + '...'
  return team1Short + ' VS ' + team2Short
}

export { Formatter }
